import styled from 'styled-components';

const StyledList = styled('ul')`
	margin: 0;
	padding: 0;
	list-style-type: none;

	li:not(:last-child) {
		margin-bottom: 12px;
	}
`;

export {
	StyledList,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SettingsPanel/styles.ts